import { useRouter } from "next/router";
import React from "react";
import { generateBlogUrl } from "src/utils/generateBlogUrl";
import Image from "next/image";
import classes from "./styles.module.scss";
import EPButton from "components/UI/EPButton";
import Link from "next/link";
import Text from "components/Brand/Text";

const BlogCard = ({ blog, noTag }) => {
  const router = useRouter();

  const formatDate = blogDate => {
    const date = new Date(blogDate);
    return date.toLocaleDateString("en-us", {
      month: "short",
      year: "numeric",
    });
  };

  return (
    <article className={classes.blogCard}>
      <div className={classes.top}>
        <a
          className={classes.link}
          href={generateBlogUrl(blog.data)}
          aria-label={blog.data.customTitle || blog.data.title}
        ></a>
        <div className={classes.imageContainer}>
          <Image
            src={blog.data.image}
            alt={
              blog.data.imageAlt ||
              blog.data.imageTitle ||
              blog.data.caption ||
              blog.data.title
            }
            title={
              blog.data.imageTitle ||
              blog.data.imageAlt ||
              blog.data.caption ||
              blog.data.title
            }
            // style={{
            //   objectFit: "cover",
            // }}
            width={350}
            height={300}
          />
          {/* <div className={classes.imageOverlay}></div> */}
        </div>
        <div className={classes.tagContainer}></div>
        <span className={classes.date}>
          {formatDate(blog.data.dateModified || blog.data.date)}
        </span>
        <Text as={noTag ? "h2" : "div"} className={classes.title}>
          {blog.data.customTitle || blog.data.title}
        </Text>
        <div className={classes.description}>{blog.data.excerpt}</div>
      </div>
      <div className={classes.bottom}>
        <EPButton variant="primary" href={generateBlogUrl(blog.data)}>
          Read More
        </EPButton>
      </div>
    </article>
  );
};

export default BlogCard;
